import axios from '@/api/config';

const generator = {
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/generator/pageList`, data);
  },
  generateFile(data) {
    return axios.post(`${process.env.BASE_URL}/generator/generateFile`, data);
  },
  getTableSchemas(data) {
    return axios.get(`${process.env.BASE_URL}/generator/getTableSchemas`, {params: data});
  },
  getColumns(data) {
    return axios.get(`${process.env.BASE_URL}/generator/getColumns`, {params: data});
  }
}

export default generator;



// WEBPACK FOOTER //
// ./src/api/generator.js